/// <reference path="../assets.d.ts" />
import { Asset } from 'expo-asset';
import type { ImageSource } from '../image.types';
import sciFiLightAsset from './sci-fi-light.webp';

// Web variant. The bundled WebP's URL, which the image layer fetches.
export const sciFiLight: ImageSource = Asset.fromModule(sciFiLightAsset).uri;
